export default [
  {
    name: 'BankingCorrespondentsList',
    path: 'settings/banking-correspondents',
    component: () => import('pages/settings/banking-correspondents/BankingCorrespondentsList.vue')
  },
  {
    name: 'BankingCorrespondentsCreate',
    path: 'settings/banking-correspondents/new',
    component: () => import('pages/settings/banking-correspondents/form/BankingCorrespondentsForm.vue')
  },
  {
    name: 'BankingCorrespondentsEdit',
    path: 'settings/banking-correspondents/:id/edit',
    component: () => import('pages/settings/banking-correspondents/form/BankingCorrespondentsForm.vue')
  }
]
